// Minnesotaänger Mini App — message meta (bubble timestamp).
// Trimmed from telegram-tt: views, replies, edited marker and outgoing
// status were removed; only the message time remains. telegram-tt renders
// it inside the bubble (metaPosition 'in-text'), floated by MessageMeta.scss.

import { memo } from '../../../lib/teact/teact';

import type { ApiMiniAppMessage } from '../../../api/miniapp/types';

import { formatMessageTime } from '../helpers/dateFormat';

import './MessageMeta.scss';

type OwnProps = {
  message: ApiMiniAppMessage;
};

const MessageMeta = ({ message }: OwnProps) => (
  <span className="MessageMeta" dir="ltr">
    <span className="message-time">{formatMessageTime(message.created_at)}</span>
  </span>
);

export default memo(MessageMeta);
